import { createBrowserRouter } from 'react-router-dom';
import { App } from './components/routes/App/App';
import { Products } from './components/routes/Products/Products';
import { Product } from './components/routes/Product/Product';
import { Settings } from './components/routes/Settings/Settings';
import { Login } from './components/routes/Login/Login';
import { AppLayout } from './components/routes/AppLayout/AppLayout';
import { Conversations } from './components/routes/Conversations/Conversations';
import { Conversation } from './components/routes/Conversation/Conversation';
import { Merchant } from './components/routes/Merchant/Merchant';
import { Statistics } from './components/routes/Statistics/Statistics';
import { Billing } from './components/routes/Billing/Billing';
import { NotFound } from './components/routes/NotFound/NotFound';
import { ImportProduct } from './components/routes/ImportProduct/ImportProduct';
import { Integrations } from './components/routes/Integrations/Integrations';
import { Integration } from './components/routes/Integrations/Integration';
import { WebsitePublish } from './components/routes/Products/WebsitePublish/WebsitePublish';

const router = createBrowserRouter([
	{
		path: '',
		element: <App />,
		children: [
			{ path: '', element: <Login /> },
			{
				element: <AppLayout />,
				children: [
					{
						path: 'products',
						element: <Products />,
					},
					{
						path: 'products/:id',
						element: <Product />,
					},
					{
						path: 'products/add',
						element: <Product />,
					},
					{
						path: 'products/import',
						element: <ImportProduct />,
					},
					{
						path: 'products/:productID/publish/:merchantIntegrationID',
						element: <WebsitePublish />,
					},
					{ path: 'conversations', element: <Conversations /> },
					{ path: 'conversations/:id', element: <Conversation /> },
					{ path: 'merchant', element: <Merchant /> },
					{ path: 'statistics', element: <Statistics /> },
					{ path: 'settings', element: <Settings /> },
					{ path: 'integrations', element: <Integrations /> },
					{ path: 'integrations/connect/:key', element: <Integration /> },
					{ path: 'integrations/details/:id', element: <Integration /> },
					{ path: 'billing', element: <Billing /> },
					{ path: '*', element: <NotFound /> },
				],
			},
		],
	},
]);

export { router };
